import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { http, formatError } from "@/lib/api";
import { MapPin, CheckCircle2, Loader2 } from "lucide-react";

function TeamCol({ label, names, right }) {
  return (
    <div className={`flex-1 min-w-0 ${right ? "text-right" : ""}`}>
      <div className="text-[10px] font-bold uppercase tracking-wider text-[#5C7285]">{label}</div>
      {names.map((n, i) => (
        <div key={i} className="text-sm font-bold pv-text-dark truncate">{n}</div>
      ))}
    </div>
  );
}

export default function LastMatchCard({ match }) {
  const navigate = useNavigate();
  const [submitted, setSubmitted] = useState(match?.submitted);
  const [loading, setLoading] = useState(false);
  if (!match) return null;
  const win = match.result === "WIN";

  const submit = async () => {
    setLoading(true);
    try {
      await http.post(`/matches/${match.id}/submit-dupr`);
      setSubmitted(true);
      toast.success("Result submitted to DUPR");
    } catch (e) {
      toast.error(formatError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="rounded-2xl bg-white border border-[#0E395F]/10 shadow-[0_10px_30px_-12px_rgba(14,57,95,0.12)] p-5" data-testid="last-match-card">
      <div className="flex items-center justify-between">
        <span className="text-xs font-bold uppercase tracking-widest text-[#5C7285]">Last Match</span>
        <span className="text-xs text-[#5C7285]">{match.when}</span>
      </div>
      <div className="flex items-center gap-3 mt-3">
        <TeamCol label="You" names={["You", match.partner?.name].filter(Boolean)} />
        <div className="text-center shrink-0">
          <div className="text-xl font-black font-display pv-text-dark whitespace-nowrap" data-testid="last-match-score">{match.score_lines.join("  ")}</div>
          <span className={`inline-block mt-1 rounded-full px-3 py-0.5 text-xs font-black ${win ? "bg-[#005F19] text-white" : "bg-[#0E395F]/10 text-[#0E395F]"}`}>{match.result}</span>
        </div>
        <TeamCol label="Opponents" names={[match.opponent?.name, match.opponent_partner?.name].filter(Boolean)} right />
      </div>
      <div className="flex items-center gap-1 text-xs text-[#5C7285] mt-3"><MapPin size={12} />{match.location}</div>
      <div className="flex gap-3 mt-4">
        {submitted ? (
          <span data-testid="dupr-submitted" className="flex-1 text-center rounded-full bg-[#005F19]/10 text-[#005F19] font-bold py-2.5 text-sm inline-flex items-center justify-center gap-1">
            <CheckCircle2 size={16} /> Submitted
          </span>
        ) : (
          <button data-testid="add-to-dupr-btn" onClick={submit} disabled={loading} className="flex-1 bg-[#BED445] text-black font-extrabold rounded-full py-2.5 text-sm hover:bg-[#c9df55] transition-colors disabled:opacity-60 inline-flex items-center justify-center gap-1">
            {loading && <Loader2 size={14} className="animate-spin" />} Add Result to DUPR
          </button>
        )}
        <button data-testid="view-match-btn" onClick={() => navigate("/passport")} className="flex-1 border-2 border-[#0E395F] text-[#0E395F] font-bold rounded-full py-2.5 text-sm hover:bg-[#0E395F] hover:text-white transition-colors">
          View Match
        </button>
      </div>
    </section>
  );
}
